export default "__VITE_ASSET__BihubyQH__"